import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "https://www.emperorhaileselassie.org";

export default function Seo({ title, description, path = "/", schema = null }) {
  const full = `${title} | EHSIMFFA`;
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
